// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Pagination_pagination__9X6Z- {
  animation: Pagination_init__eobKr 0.5s both 0.5s;
  margin-top: 50px;
  display: flex;
  justify-content: center;
  align-items: center;
}

.Pagination_pagination__9X6Z- .Pagination_customPage__kJ0ZM {
  display: flex;
  justify-content: center;
  align-items: center;
}

@media print {
  .Pagination_pagination__9X6Z- {
    display: none !important;
  }
}

@keyframes Pagination_init__eobKr {
  from {
    opacity: 0;
    transform: translateY(10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
`, "",{"version":3,"sources":["webpack://./src/components/Shared/Pagination/Pagination.module.css"],"names":[],"mappings":"AAAA;EACE,gDAA8B;EAC9B,gBAAgB;EAChB,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE;IACE,wBAAwB;EAC1B;AACF;;AAEA;EACE;IACE,UAAU;IACV,2BAA2B;EAC7B;EACA;IACE,UAAU;IACV,wBAAwB;EAC1B;AACF","sourcesContent":[".pagination {\n  animation: init 0.5s both 0.5s;\n  margin-top: 50px;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n.pagination .customPage {\n  display: flex;\n  justify-content: center;\n  align-items: center;\n}\n\n@media print {\n  .pagination {\n    display: none !important;\n  }\n}\n\n@keyframes init {\n  from {\n    opacity: 0;\n    transform: translateY(10px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"pagination": `Pagination_pagination__9X6Z-`,
	"init": `Pagination_init__eobKr`,
	"customPage": `Pagination_customPage__kJ0ZM`
};
export default ___CSS_LOADER_EXPORT___;
